export function getByteLength(contents: string) {
  return new TextEncoder().encode(contents).length;
}
